import { useCallback, useEffect, useRef, useState } from "react";
import useShopContext from "./useShopContext";
import moment from "moment";

const useSetInterval = ({ intervalMin }) => {
  const [showModal, setShowModal] = useState(false);

  const intervalId = useRef(null);

  const {
    shop: { createdAt },
  } = useShopContext();

  const startInterval = useCallback((endTime) => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
    }

    intervalId.current = setInterval(() => {
      const timeDiff = moment.duration(endTime.diff(moment()));
      const remainingSeconds = Math.floor(timeDiff.asSeconds());
      if (remainingSeconds >= 0) {
        setShowModal(false);
      }
      if (remainingSeconds <= 0) {
        clearInterval(intervalId.current);
        intervalId.current = null;
        setShowModal(true);
      }
    }, 10000);
  }, []);

  useEffect(() => {
    if (createdAt) {
      const tenMinutes = moment.duration(intervalMin, "minutes");
      const timeStart = moment.unix(createdAt.seconds);
      const endTime = timeStart.add(tenMinutes);
      startInterval(endTime);
    }

    return () => {
      if (intervalId.current) {
        clearInterval(intervalId.current);
        intervalId.current = null;
      }
    };
  }, [createdAt, intervalMin]);

  return showModal;
};

export default useSetInterval;
